<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="Add Poster"  @hide="closeModal()">
    <div class="" v-if="show">
      <b-row>
        <b-col sm="5">
          <p-multiselect v-model="form.category" label="Select Category" name="category" :handler="$v" :formData="form" :options="categoryList" textKey="key" textValue="value" />
        </b-col>
        <b-col sm="4">
          <p-dropdown v-model="form.type" label="Device Type" name="type" :handler="$v" :formData="form" :options="deviceList" textKey="key" textValue="label"/>
        </b-col>
        <b-col sm="3">
          <p-input v-model="form.order" label="Order" name="order" :handler="$v" :formData="form" type="text"/>
        </b-col>
        <b-col sm="6">
          <p-date-time v-model="form.daterange" label="Date Range" name="daterange" :handler="$v" :formData="form" :singleDatePicker="false"/>
        </b-col>
        <b-col sm="3">
          <p-switch v-model="form.auth_required" label="Authentication Required" name="auth_required" :handler="$v" :formData="form"/>
        </b-col>
        <b-col sm="3">
          <p-switch v-model="form.status" label="Status" name="status" :handler="$v" :formData="form"/>
        </b-col>
        <b-col sm="12">
          <p-radio v-model="form.actionType" label="Select Action" name="actionType" :handler="$v" :formData="form" :options="actionList" />
        </b-col>
        <template v-if="form.actionType !== 4">
          <b-col sm="12" v-if="[0,3].includes(form.actionType)">
            <p-input v-model="form.action" label="Url" name="action" :handler="$v" :formData="form" type="text" />
          </b-col>
          <b-col sm="12" v-if="form.actionType===2">
            <p-dropdown v-model="form.action" label="Select Promotion" name="action" :handler="$v" :formData="form" :options="promotionList" textKey="Name" textValue="Name"/>
          </b-col>
          <template v-if="form.actionType===1">
            <b-col sm="4">
              <p-dropdown v-model="form.brand" label="Select Platform" name="brand" :handler="$v" :formData="form" :options="brandList" textKey="Code" textValue="Name" @change="getGameList()"/>
            </b-col>
            <b-col sm="8">
              <p-dropdown v-model="form.game" label="Select Game" name="game" :loading="fetchingGames" :handler="$v" :formData="form" :options="gameList" textKey="GameId" textValue="GameName" />
            </b-col>
          </template>
        </template>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-tabs>
            <b-tab v-for="(value, index) in LANG" :key="index" :title="value.Name">
              <b-row>
                <b-col sm="6">
                  <p-image v-model="form.background[value.Lang]" label="Desktop Image" :checkKey="value.Lang" :name="`background`" :handler="$v" :formData="form" />
                </b-col>
                <b-col sm="6">
                  <p-image v-model="form.button[value.Lang]" label="Mobile Image" name="button" :handler="$v" :formData="form" />
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </div>
    <br>
    <b-button variant="success" @click="add()" :disabled="requesting">Add</b-button>
    <b-button variant="outline-danger" @click="closeModal()">Cancel</b-button>
  </b-modal>
</template>

<script>

import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { required } from 'vuelidate/lib/validators'
import { PInput, PMultiselect, PDropdown, PDateTime, PRadio, PSwitch, PImage } from '../../../components'

export default {
  props: {
    showAddModal: {
      type: Boolean,
      default: false
    },
    promotionList: {
      type: Array,
      default: []
    },
    brandList: {
      type: Array,
      default: []
    },
    categoryList: {
      type: Array,
      default: []
    },
    deviceList: {
      type: Array,
      default: []
    },
    actionList: {
      type: Array,
      default: []
    }
  },
  data: () => {
    return {
      fetchingGames: false,
      gameList: [],
      requesting: false,
      form: {
        daterange: '',
        type: null,
        order: 1,
        category: '',
        actionType: 4,
        action: '',
        brand: null,
        game: null,
        auth_required: 0,
        status: 1,
        background: [],
        button: [],
        errorMessages: {
          daterange: {
            required: 'Please select date range'
          },
          type: {
            required: 'Please select Device Type'
          },
          order: {
            required: 'Order is required'
          },
          category: {
            required: 'Please set category'
          },
          actionType: {
            required: 'Please select action type'
          },
          action: {
            checkRequired: 'Action is required'
          },
          brand: {
            checkRequired: 'Please select brand'
          },
          game: {
            checkRequired: 'Please select game'
          },
          auth_required: {
            required: 'Auth required must be set.'
          },
          status: {
            required: 'Status is required'
          },
          background: {
            required: 'Upload background image'
          },
          button: {
            required: 'Required'
          }
        }
      }
    }
  },
  validations: {
    form: {
      daterange: { required },
      type: { required },
      order: { required },
      category: { required },
      actionType: { required },
      action: {
        checkRequired () {
          return !([0, 3].includes(this.actionType) && this.form.action === '')
        }
      },
      brand: {
        checkRequired () {
          return !(this.actionType === 1 && this.form.brand === '')
        }
      },
      game: {
        checkRequired () {
          return !(this.actionType === 1 && this.form.game === '')
        }
      },
      auth_required: { required },
      background: {
        $each: {
          required
        }
      },
      button: {},
      status: { required }
    }
  },
  components: {
    PInput,
    PMultiselect,
    PDropdown,
    PDateTime,
    PRadio,
    PSwitch,
    PImage
  },
  computed: {
    show: {
      get: function () {
        return this.showAddModal
      },
      set: function () {
        return this.showAddModal
      }
    }
  },
  watch: {
    'form.actionType': function () {
      this.form.action = (this.form.actionType === 2) ? null : ''
      this.form.brand = null
      this.form.game = null
    }
  },
  methods: {
    closeModal () {
      this.$emit('cancelAdd')
      this.form.daterange = ''
      this.form.type = null
      this.form.order = 1
      this.form.category = ''
      this.form.actionType = ''
      this.form.action = ''
      this.form.brand = null
      this.form.game = null
      this.form.auth_required = 0
      this.form.status = 1
      this.form.background = []
      this.form.button = []
      this.$v.form.$reset()
    },
    async getGameList () {
      try {
        this.form.game = null
        this.fetchingGames = true
        let { data } = await this.$http.get(this.API_ENDPOINT + `/game/gamelist?brand=${this.form.brand}`, { headers: { 'Content-Type': 'application/json' } })
        let game = data.list.map(x => { return { GameId: `${x.GameId}-${x.GameKindId}`, GameName: x.GameName } })
        this.gameList = game
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        this.fetchingGames = false
      }
    },
    async add () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        }
        this.requesting = true
        let formData = new FormData()
        let category = this.form.category.reduce((prev, next) => { return prev + `${next.key},` }, '')
        category = category.slice(0, category.lastIndexOf(','))
        formData.append('category', category)
        formData.append('type', this.form.type)
        formData.append('order', this.form.order)
        formData.append('enableDate', this.form.daterange[0])
        formData.append('disableDate', this.form.daterange[1])
        formData.append('auth_required', this.form.auth_required)
        formData.append('status', this.form.status)
        formData.append('actionType', this.form.actionType)
        formData.append('action', (this.form.actionType === 1) ? `${this.form.game}-${this.form.brand}` : this.form.action)
        for (var key in this.LANGID) {
          formData.append('lang', key)
          formData.append('background', this.form.background[key] || '')
          formData.append('button', this.form.button[key] || '')
        }
        await this.$http.post(this.API_ENDPOINT + '/cms/poster/add', formData, { headers: { 'Content-Type': 'application/json' } })

        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Poster Added Successfully')
        this.closeModal()
      } catch (err) {
        let code = err.response.data.code
        let msg = err.response.data.msg
        Events.$emit('alert', VueNotifications.types.error, code, msg)
      } finally {
        this.requesting = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/poster/Poster/AddPoster.vue